<template>
  <div>
    <div class="donate__container--flex">
            <header style=" line-height: normal; text-align: center; margin-bottom: 25px;">
            <p style="text-align: center;"><strong>Thank you for your commitment to supporting Tri-State NCSY!</strong></p>
            <p>This year, generous supporters like you will empower thousands of teens to engage with Tri-State NCSY in various settings, including their public schools, local coffee shops, and community events. Your investment enables us to offer a wide range of transformative programs, including regional conventions, social action events, summer trips, and more. We are sincerely grateful for your contribution!</p>
            <p>Your support of Tri-State NCSY not only sustains our impact in communities across New York, New Jersey, and Connecticut, but also fuels our ambitious expansion efforts to reach even more Jewish teens. Thank you for partnering with us to shape the future of the Jewish community!</p>
            <p>NCSY is the International youth movement of the OU, which is a registered 501c3.<br>
            100% of this gift is tax-deductible.</p>
            </header>

        <div class="donation-wrapper">

        <div class="donate__form wizard-steps"  style="margin-top: 0px;width: 100%;margin: 0px;">

    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Donation Amount">
            <div style="position: relative">
              <AmountSelector />
              <ErrorLabel field="amount" style="text-align: right" />
            </div>
          </FormSection>
          <FormSection v-if="form.amount">
            <TransactionFee />
          </FormSection>
          <FormSection title="Donation Frequency">
            <div class="frequency">
              <PaymentOptions addSplit addMonthly monthesSelector/>
            </div>
          </FormSection>
          <FormSection title="Donation Designation">
            <FormRow class="designation" inline>
              <FormSelect field="applications.0.campaign">
                <option selected="selected" value="General Donation">
                  General Donation
                </option>
                <option value="4G">4G donation</option>
                <option value="Central and Southern NJ">Central and Southern NJ donation</option>
                <option value="Connecticut">Connecticut donation</option>
                <option value="Englewood">Englewood donation</option>
                <option value="Teaneck">Teaneck donation</option>
                <option value="Metrowest NJ">Metrowest NJ donation</option>
                <option value="PIVOT">Pivot donation</option>
                <option value="JSU Donation">JSU Public School Club</option>
                <option value="Summer Scholarship">Summer Programs Scholarship</option>
                <option value="Scholarship">Regional Convention Scholarship</option>
                <option value="Israel Scholarship">Gap Year Scholarship</option>
                <option value="Manhattan Donation">Manhattan Donation</option>
                <option value="Riverdale Donation">Riverdale Donation</option>
                <option value="Queens">Queens Donation</option>
                <option value="Brooklyn Donation">
                  Brooklyn/Staten Island Donation
                </option>
                <option value="Westchester Donation">Westchester Donation</option>
                <option value="Long Island Donation">Long Island Donation</option>
                <option value="Rockland Donation">Rockland County Donation</option>
                <option value="Great Neck">Great Neck Donation</option>
                <!-- <option value="Great Neck">Great Neck Building Fund</option> -->
                <!-- <option value="Yarchei Kallah">NY Yarchei Kallah</option> -->
                <!-- <option value="Over The Edge">Over the Edge</option> -->
                <option value="Fri Night of Inspiration">
                  Friday Night of Inspiration
                </option>
                <!-- <option value="Project Community">Project Community</option> -->
                <option value="TJJ for Moms">TJJ For Moms</option>
                <option value="JSU Expansion">JSU Expansion</option>
                <option value="Tefillin Campaign">Tefillin Campaign</option>
                <!-- <option value="iNCSYder">iNCSYder</option> -->
              </FormSelect>
              <ErrorLabel field="applications.0.campaign" style="text-align: right" />
            </FormRow>
          </FormSection>
          <FormSection title="Notes">
            <FormRow>
              <FormInput type="textarea" class="width-half" field="custom.Notes" />
            </FormRow>
          </FormSection>
          <FormSection>
            <InHonorOf />
          </FormSection>
          <FormSection title="Personal Information">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                <Consent privacy="https://ncsy.org/privacy-policy/"/>
                    </FormRow>                   
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount btnText="Donate Now" />
        </PaymentForm>
      </div>
    </div>

  </div>
</div>
  </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, watch } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";

export default defineComponent({
  setup() {
    const { getValue, settings, setValue, form } = usePaymentForm();

    const params = queryParams();

    if (params.campaign) {
      //@ts-ignore
      if (params.campaign === "TJJ") {
        setValue("applications.0.campaign", "TJJ For Moms");
      }
    }


    watch(
      () => form.value.applications[0].campaign,
      (val) => {
        if (val == "Great Neck" || !val) {
          setValue("applications.0.subCampaign", "GN NCSY Office");
        } else {
          setValue("applications.0.subCampaign", "");
        }
      }
    );

    return {
      form,
      getValue,
      settings,
      setValue,
    };
  },
});
</script>
<style scoped lang="scss">
::v-deep h2 {
  color: #1aa8d3;
  font-weight: bold;
  font-size: 22px;
  margin-bottom: 25px;
}

::v-deep .form-container.ou-donation-form {
  max-width: 100%;
}
::v-deep
  .styled-radio-container--ou-donation.styled-radio-container
  input[type="radio"]:checked
  + label {
  background: #1aa8d3;
}
::v-deep hr {
  background: none;
  box-shadow: none;
  height: 0;
  border: none;
  margin-bottom: 20px;
  border-bottom: 1px solid #efefef;
}

::v-deep .styled-radio--ou-donation.styled-radio .radio-part {
  @media (min-width: 720px) {
    min-width: 33.3%;
    flex: 1;
    max-width: 33.3%;
  }
}

.designation {
  display: flex;
  width: 100%;
  position: relative;
  ::v-deep select {
    flex: 1;
    min-width: 50%;
    max-width: 50%;
    margin-right: 1%;
  }
  ::v-deep select:last-child {
    margin-right: 0;
  }
}
</style>
